export default __webpack_public_path__ + "static/no-identifying-logs-f318f4029ba8583bec99e2682b47ce36.png";